import React, { useState, useEffect } from "react";
import Api from "../../lib/componentApi";
import AppErrors from "../Common/AppErrors";

const Announcements = ({ lat, lon, userAddressId }) => {
  const [announcements, setAnnouncements] = useState([]);
  const [popupContent, setPopupContent] = useState(null);
  useEffect(() => {
    if (!announcements.length) {
      Api.post(
        "/api/announcements",
        { lat, lon, userAddressId },
        (response, errors) => {
          if (errors) {
            if (errors === 503) {
              this.setState(() => {
                throw errors;
              });
            } else {
              console.log(errors);
            }
          } else if (response.code) {
            console.log(response, "code-announcements");
          } else {
            if (response.length) setAnnouncements(response);
          }
        }
      );
    }
  }, [announcements]);
  const onClickClose = () => {
    const body = document.body;
    body.classList.remove("body-overflow");
    setPopupContent(null);
  };
  const onClickContent = announcement => {
    if (announcement) {
      const body = document.body;
      body.classList.add("body-overflow");
      setPopupContent({
        title: announcement.title,
        message: announcement.content
      });
    }
  };
  return (
    <>
      {(announcements &&
        announcements.length &&
        announcements.map(announcement => (
          <div className="container" >
            <div
              className={`restaurant-discount ${announcement.announcementType.name === 'Warning'  ? "orange" : "" } `}
              style={{
                background:
                  (announcement.announcementType &&
                    announcement.announcementType.color) ||
                  "#1fb6ff"
              }}
            >
              <div className="d-flex justify-content-between align-items-center">
                <div>
                  <h4>{announcement.title}</h4>
                  <p>{announcement.message}</p>
                </div>
                {announcement.content && (
                  <i
                    style={{ zIndex: 999 }}
                    onClick={() => onClickContent(announcement)}
                    className="icon icon-arrow-left"
                  />
                )}
              </div>
              <div className="svg">
                {announcement.announcementType.name === 'Warning'  && (
                  <img src="svg/orange-local-e.svg" />
                )
                ||
                <img src="svg/footer-local-e.svg" />
                }
              </div>
            </div>
          </div>
        ))) || <noscript />}
      {popupContent && (
        <AppErrors
          message={popupContent.message}
          title={popupContent.title}
          onClickClose={onClickClose}
        />
      )}
    </>
  );
};

export default Announcements;
